import { Routes, Route } from 'react-router-dom';

import path from '@/routes/constants';

import Plans from 'pages/billing/plans/Index';
import CSVCallingRates from 'pages/billing/plans/edit/csv/';
import CSVNumberBlockRates from 'pages/billing/plans/edit/csv-number-block-rate';

export default function PlanRoutes() {
    const { CSVCALLINGRATES, CSVNUMBERBLOCKRATES } = path;
    return (
        <Routes>
            <Route index element={<Plans />} />
            <Route path={CSVCALLINGRATES} element={<CSVCallingRates />} />
            <Route
                path={CSVNUMBERBLOCKRATES}
                element={<CSVNumberBlockRates />}
            />
        </Routes>
    );
}
